import React, { Component } from "react";
import { connect } from "react-redux";
import SharedFunctions from "../../utils/SharedFunctions";
import "./MissingSkuModal.css";
import MissingSkuModalComponent from "./MissingSkuModalComponent";
import {
  getShelves,
  setVerifyOperator,
  reportMissingItem,
  resetState,
  setMissingSkuFound,
  setState,
  forceLiftShelf,
  cancelLiftShelf,
  setVerifyForceLiftShelf,
  resetVerifyForceLiftShelf,
  setShowMissingSkuRemovalAutostoreDisabled,
  fetchSettingSkuRemovalAutostoreDisabled,
} from "../../lib/store/reducers/missingSkuReducer";
import { MissingStockItemRemovalResolutionActions , AUTOSTORE_SHELF} from "../../utils/Constants";
import {  SHOW_WORKSTATION_INSTRUCTION_ERROR_CODE } from "../../utils/constants/errorCodes";
import WarningModal from "../../components/WarningModal/WarningModal";
import SkuEndpoints from "../../lib/sku/SkuEndpoints";
import OperatorInputModal from "../OperatorInputModal/OperatorInputModal";
import MissingSkuWarningModal from "../MissingSkuWarningModal/MissingSkuWarningModal";
import { MISSING_SKU_MODAL } from "../../utils/constants/componentConstants";
import { Loader, Dimmer } from "semantic-ui-react";

class MissingSkuModal extends Component {

  constructor(props) {
    super(props);
    this.missingSkuFound = this.missingSkuFound.bind(this);
    this.operatorInput = this.operatorInput.bind(this);
    this.closeWarningModal = this.closeWarningModal.bind(this);
    this.confirmSkuRemovalCallback = this.confirmSkuRemovalCallback.bind(this);
  }


  async componentDidMount() {
    const { boxItem, currentOrderNumber, cartNumber, loginState } = this.props;
    this.props.getShelves(boxItem, loginState.branchID);
    this.props.fetchSettingSkuRemovalAutostoreDisabled();
    // awaitable/promise
    var cartId = cartNumber?.toString();
    cartId = cartId?.substring(0,cartId.length -1);
    SharedFunctions.LogPopupShownEvent( {modalComponentName: MISSING_SKU_MODAL,
      skuId: boxItem.skuID,
      orderNumber: currentOrderNumber,
      quantity: boxItem.reservedQuantity - boxItem.verifiedQuantity,
      cartId: cartId});
  }

  operatorInput(authOperatorID, successCallback, failureCallback) {
    this.props.setMissingSkuFound(
      this.props.currentTotal.shelves,
      this.props.boxItem,
      this.props.missingAmount,
      this.props.fromReview,
      this.setMissingSkuFoundCallback,
      successCallback,
      failureCallback,
      authOperatorID,
      this.props.isScanIdValidationRemoveSkuRequired,
      this.props.partialDelivery,
      this.props.boxItem.isRxItem
    );
  }

  closeOperatorInputModal = () => {
    this.props.setVerifyOperator(false);
  };

  confirmSkuRemovalCallback() {
      if (!this.props.isTransitBox && this.props.autostoreSkuRemovalDisabled && this.props.foundShelves.some( z => z.shelfNumber == AUTOSTORE_SHELF )) {
      this.props.setShowMissingSkuRemovalAutostoreDisabled(true);
    } else if (!this.props.isTransitBox && !this.props.removeSkuAccess) {
      this.props.setVerifyOperator(true);
    } else {
      this.props.setMissingSkuFound(
        this.props.currentTotal.shelves,
        this.props.boxItem,
        this.props.missingAmount,
        this.props.fromReview,
        this.setMissingSkuFoundCallback,
        undefined,
        undefined,
        undefined,
        this.props.isScanIdValidationRemoveSkuRequired,
        this.props.partialDelivery,
        this.props.boxItem.isRxItem
      );
    }
    this.closeWarningModal();
  }

  closeWarningModal() {
    if (this.props.isTransitBox){
      this.onCloseClearState()
    }else{
      this.props.setState({ showRemovalWarning: false, isLoadingShelves: false });
    }
  }

  setMissingSkuFoundCallback = (res) => {
    this.props.foundSkuCallback(res);
    this.props.resetState();
    this.props.onClose();
  };

  missingSkuFound(shelves) {
    const missingAmount = this.props.missingAmount;
    const foundAmount = shelves.map((s) => s.foundQuantity).reduce((sum, value) => sum + value, 0);

    if (missingAmount > foundAmount) {
      this.props.setState({
        showRemovalWarning: true,
        amountToRemove: missingAmount - foundAmount,
      });
    } else {
      this.props.setMissingSkuFound(
        shelves,
        this.props.boxItem,
        missingAmount,
        this.props.fromReview,
        this.setMissingSkuFoundCallback,
        undefined,
        undefined,
        undefined,
        this.props.isScanIdValidationRemoveSkuRequired,
        false,
        this.props.boxItem.isRxItem
      );
    }
  }

  _areAlternativeShelvesFoundForItem(boxItem, foundShelves) {
    /**
     * The idea is that there should be a shelf that is not
     * among those where the item could have been picked up
     * from, therefore we have to check both boxItem.shelfNumber and
     * any oter shelves included in boxItem.shelfNumbers.
     *
     * If there is one, then it is considered an alternative.
     */
    return foundShelves.some((shelf) => boxItem.shelfNumber !== shelf.shelfNumber);
  }

  reportMissingItem = (reason, boxItem) => {
    this.props.reportMissingItem(reason, boxItem);
  };

  dismissMissingSku(cancelationContext = void 0) {
    if (!cancelationContext) {
      return;
    }

    const missingStockItemID = cancelationContext.missingStockItemID;
    if (missingStockItemID === void 0 || missingStockItemID === 0) {
      return;
    }

    const cancelResolutionAction = cancelationContext.alterantiveShelvesExist
      ? MissingStockItemRemovalResolutionActions.CancelledWithAlternatives
      : MissingStockItemRemovalResolutionActions.Cancelled;

    SkuEndpoints.updateMissingStockItemState(missingStockItemID, cancelResolutionAction);
  }

  onCloseClearState = () => {
    const { onClose, boxItem } = this.props;

    const alterantiveShelvesExist = this._areAlternativeShelvesFoundForItem(
      boxItem,
      this.props.foundShelves
    );
    this.props.resetState();
    onClose(() =>
      this.dismissMissingSku({
        missingStockItemID: this.props.missingStockItemID,
        alterantiveShelvesExist,
      })
    );
  };

  forceLiftShelf = (shelfNumber) => {
    this.props.setVerifyForceLiftShelf(shelfNumber);
  };

  cancelLiftShelf = (shelfNumber) => {
    this.props.cancelLiftShelf(shelfNumber, this.props.cartID);
  };

  forceLiftShelfApproved = () => {
    this.props.forceLiftShelf(this.props.currentShelf, this.props.cartID);
  };

  forceLiftShelfDeclined = () => {
    this.props.resetVerifyForceLiftShelf();
  };

  render() {
    const {
      open,
      boxItem,
      foundShelves,
      isLoadingShelves,
      missingAmount,
      currentTotal,
      verifyOperator,
      verifyForceLiftShelf,
      reasonCode,
      missingButtonLoading,
      showRemovalWarning,
      amountToRemove,
      forcedLiftShelves,
      currentShelf,
      forceLiftShelfLoading,
      forceLiftShelfFailed,
      isScanIdValidationRemoveSkuRequired,
      isTransitBox = false,
      rxWest = false
    } = this.props; // 'boxItem' is 'missingBoxItem' in the application state.

    if (!showRemovalWarning && isTransitBox && missingAmount >0){
      this.props.setState({
        showRemovalWarning: true,
        amountToRemove: missingAmount,
      });
    }
    return (
      <div className={"ModalWrapper"}>
        <MissingSkuModalComponent
          boxItem={boxItem}
          currentTotal={currentTotal}
          foundShelves={foundShelves}
          isLoadingShelves={isLoadingShelves}
          missingAmount={missingAmount}
          missingButtonLoading={missingButtonLoading}
          missingSkuFound={this.missingSkuFound}
          onCloseClearState={this.onCloseClearState}
          open={open}
          reasonCode={reasonCode}
          reportMissingItem={this.reportMissingItem}
          forceLiftShelfCallback={this.forceLiftShelf}
          cancelLiftShelfCallback={this.cancelLiftShelf}
          forcedLiftShelves={forcedLiftShelves}
        />
        <OperatorInputModal
          open={verifyOperator }
          submitCallback={this.operatorInput}
          onClose={this.closeOperatorInputModal}
          submitButtonText="TA BORT"
          headerText="Stryk vara"
          isScanIdValidationRequired={isScanIdValidationRemoveSkuRequired}
        />
        <MissingSkuWarningModal
          open={showRemovalWarning && !rxWest}
          onClose={this.closeWarningModal}
          onAccept={this.confirmSkuRemovalCallback}
          header="Ta bort artikel?"
        >
          <h1>
            Det saknas fortfarande <span className="red-text">{amountToRemove}</span> st:
          </h1>
          <h3>{boxItem.name}</h3>
          <h1>Vill du stryka dessa?</h1>
        </MissingSkuWarningModal>

        {/* Show warning regarding rx items not being able to be removed (this is done in LRX). */}
        <MissingSkuWarningModal
          open={showRemovalWarning && rxWest}
          onClose={this.closeWarningModal}
          onAccept={this.onCloseClearState}
          header="Saknad artikel"
        >
          <h1>
            Det saknas fortfarande <span className="red-text">{amountToRemove}</span> st:
          </h1>
          <h3>{boxItem.name}</h3>
          <h2>Strykning av Rx-artiklar görs via LRX</h2>
          <h1>Återgå till plocklista?</h1>
        </MissingSkuWarningModal>

        <WarningModal
            open={this.props.showSkuRemovalAutostoreDisabled}
            onClose={() => { this.props.setShowMissingSkuRemovalAutostoreDisabled( false)}}
            message={"Varan finns att plocka i Autostore och kan inte strykas!"}
            header={"Hänvisning"}
            cssClass={"warning-modal-instruction"}
            autoClose={false}
            isCartInstruction={false} //this.state.isCartInstruction
            workstationID={this.props.loginState.workstationID}
            cartSuggestion={null} //this.props.cartState.cartSuggestion
            changeCartSuggestion={null}
            acceptCart={null}
            closeButtonText={"OK"}
            errorCode={SHOW_WORKSTATION_INSTRUCTION_ERROR_CODE}
          />
        <MissingSkuWarningModal
          open={verifyForceLiftShelf}
          onClose={this.forceLiftShelfDeclined}
          onAccept={this.forceLiftShelfApproved}
          header="Hämta hisshylla?"
        >
          <Dimmer active={forceLiftShelfLoading} inverted>
            <Loader size="big" />
          </Dimmer>
          <h1>Vill du hämta hisshylla {currentShelf}?</h1>
          <h3>Tryck JA och gå till hissen</h3>
          {!forceLiftShelfLoading && forceLiftShelfFailed && (
            <h3>
              <span className="red-text">Något gick fel, försök igen</span>
            </h3>
          )}
        </MissingSkuWarningModal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    foundShelves: state.missingSkuReducer.foundShelves,
    isLoadingShelves: state.missingSkuReducer.isLoadingShelves,
    missingAmount: state.missingSkuReducer.missingAmount,
    currentTotal: state.missingSkuReducer.currentTotal,
    verifyOperator: state.missingSkuReducer.verifyOperator,
    verifyForceLiftShelf: state.missingSkuReducer.verifyForceLiftShelf,
    missingStockItemID: state.missingSkuReducer.missingStockItemID,
    reasonCode: state.missingSkuReducer.reasonCode,
    missingButtonLoading: state.missingSkuReducer.missingButtonLoading,
    showRemovalWarning: state.missingSkuReducer.showRemovalWarning,
    amountToRemove: state.missingSkuReducer.amountToRemove,
    forcedLiftShelves: state.missingSkuReducer.forcedLiftShelves,
    currentShelf: state.missingSkuReducer.currentShelf,
    forceLiftShelfLoading: state.missingSkuReducer.forceLiftShelfLoading,
    forceLiftShelfFailed: state.missingSkuReducer.forceLiftShelfFailed,
    showSkuRemovalAutostoreDisabled: state.missingSkuReducer.showSkuRemovalAutostoreDisabled,
    autostoreSkuRemovalDisabled: state.missingSkuReducer.autostoreSkuRemovalDisabled,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchSettingSkuRemovalAutostoreDisabled: () => dispatch(fetchSettingSkuRemovalAutostoreDisabled()),
    setShowMissingSkuRemovalAutostoreDisabled: (showWarning) => dispatch(setShowMissingSkuRemovalAutostoreDisabled(showWarning)),
    getShelves: (skuID, branchID) => dispatch(getShelves(skuID, branchID)),
    setVerifyOperator: (verifyOperator) => dispatch(setVerifyOperator(verifyOperator)),
    reportMissingItem: (reason, boxItem) => dispatch(reportMissingItem(reason, boxItem)),
    resetState: () => dispatch(resetState()),
    setState: (payload) => dispatch(setState(payload)),
    setMissingSkuFound: (
      shelves,
      boxItem,
      missingAmount,
      fromReview,
      callback,
      successCallback,
      failureCallback,
      operatorId,
      isScanIdValidationRemoveSkuRequired,
      partialDelivery,
      isRxItem,
    ) =>
      dispatch(
        setMissingSkuFound(
          shelves,
          boxItem,
          missingAmount,
          fromReview,
          callback,
          successCallback,
          failureCallback,
          operatorId,
          isScanIdValidationRemoveSkuRequired,
          partialDelivery,
          isRxItem
        )
      ),
    forceLiftShelf: (shelfNumber, cartID) => dispatch(forceLiftShelf(shelfNumber, cartID)),
    cancelLiftShelf: (shelfNumber, cartID) => dispatch(cancelLiftShelf(shelfNumber, cartID)),
    setVerifyForceLiftShelf: (currentShelf) => dispatch(setVerifyForceLiftShelf(currentShelf)),
    resetVerifyForceLiftShelf: () => dispatch(resetVerifyForceLiftShelf()),
  };
};


export default connect(mapStateToProps, mapDispatchToProps)(MissingSkuModal);